import { Trans } from "@lingui/react/macro";
import { ModalBody, Icon, Button } from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./SubscribeModalThankYou.module.scss";
import clsx from "clsx";

const SubscribeModalThankYou: React.FC<
  React.PropsWithChildren<{
    onRequestClose: () => void;
    crossBrandEnabled?: boolean; // TODO: remove when new cross brand SFO is live
    offerPageUrl: string | undefined;
  }>
> = ({ onRequestClose, crossBrandEnabled = false, offerPageUrl }) => {
  return (
    <ModalBody variant="boxed" className={styles.thankYouBody}>
      <SubscribeModalThankYouContent
        onRequestClose={onRequestClose}
        variant="wide"
        crossBrandEnabled={crossBrandEnabled}
        offerPageUrl={offerPageUrl}
      />
    </ModalBody>
  );
};

type SubscribeModalThankYouContentProps = {
  onRequestClose: () => void;
  variant: "compact" | "wide";
  crossBrandEnabled?: boolean; //TODO: remove when new cross brand SFO is live
  offerPageUrl: string | undefined;
};

export const SubscribeModalThankYouContent: React.FC<
  React.PropsWithChildren<SubscribeModalThankYouContentProps>
> = ({ onRequestClose, variant, crossBrandEnabled = false, offerPageUrl }) => {
  const onClose = () => {
    onRequestClose();
    window.location.href = offerPageUrl ?? "";
  };

  return (
    <div
      className={clsx({
        [styles.variantCompact]: variant == "compact",
        [styles.variantWide]: variant == "wide"
      })}
    >
      <div className={styles.subscriptionConfirmedMessage}>
        {" "}
        <Icon name="circle-check" size="1x" className={styles.icon} />
        <Trans>Subscription confirmed</Trans>
      </div>
      <div className={styles.thankYouMessageContainer}>
        <div
          className={clsx(styles.thankYouTitle, {
            [styles.thankYouTitleCrossBrand]: crossBrandEnabled
          })}
        >
          <Trans>
            THANK YOU
            <br /> FOR SIGNING UP
          </Trans>
        </div>
        <div className={styles.thankYouMessage}>
          <Trans>
            Silversea's exclusive offers make your all-inclusive luxury cruise
            even better
          </Trans>
        </div>
        <Button
          renderAs="button"
          variant="primary"
          dataContentPiece="back_to_website"
          onClick={onClose}
          className={clsx({
            [styles.backToWebsiteButton]: crossBrandEnabled
          })}
        >
          <Trans>Discover our offers now</Trans>
        </Button>
      </div>
    </div>
  );
};

export default SubscribeModalThankYou;
